import React from "react";
import {
  TargetIcon,
  BoltIcon,
  TrendUpIcon,
  GlobeIcon,
  RefreshIcon,
  ShieldIcon,
} from "./Icons";
import "./Services.css";

const services = [
  {
    icon: <TargetIcon size={32} />,
    title: "Executive Search",
    description:
      "C-level and VP-level placements for companies that need leaders, not just managers. We tap into networks your job boards will never reach.",
    highlight: "Leadership-focused sourcing",
  },
  {
    icon: <BoltIcon size={32} />,
    title: "Tech Recruitment",
    description:
      "Engineers, architects, data scientists — we speak their language. Our tech recruiters have engineering backgrounds, so we vet skills, not just resumes.",
    highlight: "Technical screening included",
  },
  {
    icon: <TrendUpIcon size={32} />,
    title: "Scaling & Volume Hiring",
    description:
      "Growing fast? We build dedicated hiring pipelines that help you scale your team without sacrificing quality.",
    highlight: "Flexible to your pace",
  },
  {
    icon: <GlobeIcon size={32} />,
    title: "Global Talent Sourcing",
    description:
      "Access pre-vetted remote talent from around the world. We handle timezone alignment and cultural fit assessment.",
    highlight: "International reach",
  },
  {
    icon: <RefreshIcon size={32} />,
    title: "RPO — Recruitment Process Outsourcing",
    description:
      "Embed our recruiters into your team. Get a fully managed hiring function at a fraction of building it in-house.",
    highlight: "Seamless integration",
  },
  {
    icon: <ShieldIcon size={32} />,
    title: "Retention Consulting",
    description:
      "Hiring is only half the battle. We analyze your onboarding, culture, and comp to keep your best people from walking out the door.",
    highlight: "Beyond the hire",
  },
];

const Services: React.FC = () => {
  return (
    <section className="services" id="services">
      <div className="services__container">
        <div className="services__header">
          <span className="services__tag">Services</span>
          <h2 className="services__title">
            What We Can
            <br />
            <span className="services__title--accent">Help You With</span>
          </h2>
          <p className="services__subtitle">
            Whether you need one key hire or a whole team — here's how we work.
          </p>
        </div>
        <div className="services__grid">
          {services.map((service, i) => (
            <div className="services__card" key={i}>
              <div className="services__card-icon">{service.icon}</div>
              <h3 className="services__card-title">{service.title}</h3>
              <p className="services__card-desc">{service.description}</p>
              <div className="services__card-highlight">
                <span className="services__card-highlight-dot" />
                {service.highlight}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
